import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addCartAction, setIdWalletToPay } from '../../../../../redux/slices/dagpacket';
import useVerifyEnvioSingleUser from '../../../../../hooks/envios/useVerifyEnvioSingleUser';
import { useSnackbar } from 'notistack';

function AddToCartBtn({ data }) {
  const [disabled, setDisabled] = useState(false);
  const { checkout } = useSelector((state) => state.dagpacket);
  const { cart } = checkout;
  const { id } = data;
  const dispatch = useDispatch();
  const { verifyWhenAddToCart } = useVerifyEnvioSingleUser();
  const { enqueueSnackbar } = useSnackbar();

  console.log(data);

  const getUserIdPaying = () => {
    if (data.user_rol === 'cajero') {
      return data?.hostUser_id;
    }
    return data.user_id;
  };

  // const userPayingId = data.user_rol === 'cliente-corporativo' ?

  const addItemToCart = () => {
    if (verifyWhenAddToCart(data)) {
      dispatch(addCartAction(data));
      dispatch(setIdWalletToPay(getUserIdPaying()));
      enqueueSnackbar('Item enviado al carrito de compras.', { variant: 'success' });
    } else {
      enqueueSnackbar('No se pudo enviar al carrito pues hay un item de otro usuario.', { variant: 'error' });
    }
  };

  useEffect(() => {
    const findedItem = cart.find((item) => item.object_id === id);
    if (findedItem) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [cart, id]);

  return (
    <Button
      disabled={disabled}
      sx={{ textTransform: 'initial' }}
      variant="contained"
      startIcon={<Icon icon="eva:shopping-cart-fill" />}
      onClick={addItemToCart}
    >
      Añadir al carrito
    </Button>
  );
}

export default AddToCartBtn;
